var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deleteSelectedTaskShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "deleteTask" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("language.common.delete")) + "\n      "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.cancel()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "delete-body" }, [
            _c("div", { staticClass: "delete-info" }, [
              _c("div", { staticClass: "task-popup-notice" }),
              _vm._v(" "),
              _c("div", { staticClass: "delete-info-tips" }, [
                _c("strong", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("language.popup.deleteBatchPopup.tips1", {
                        num: _vm.deleteList.length
                      })
                    )
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("language.popup.deleteBatchPopup.tips2")) +
                    "\n        "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "delete-task-button" }, [
              _c(
                "button",
                {
                  staticClass: "white-button",
                  staticStyle: { "margin-right": "5px" },
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.deleteSelectedTask()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.delete")))]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20e4bfc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e4bfc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/delete_selected_tasks_popups.vue
// module id = null
// module chunks = 